export enum BadgeCode {
    FIRST_LO = 'first_lo',
    PROGRAMME_HALFWAY = 'programme_halfway',
    PROGRAMME_END = 'programme_end',
}

export enum BadgeType {
    DEFAULT = 'default',
}

export enum BadgeStatus {
    BADGE_LOCKED = 'locked',
    BADGE_AVAILABLE = 'available',
    BADGE_CLAIMED = 'claimed',
}

export type IBadge = {
    code: BadgeCode;
    badge_type: BadgeType;
    locked: boolean;
    claimed: boolean;
};
